import React from 'react';
import PropTypes from 'prop-types';
import failImage from './fail-image-icon.svg';
import i18n from '@i18next/i18n';

export const LOAD_ERROR_MSG = i18n.t('图片加载失败，请稍后再试。');
const ICON_SIZE = 96;
const INFO_MAX_WIDTH = 428;
const INFO_MAX_HEIGHT = 216;
const IMAGE_INFO_GAP = 28;
const TEXT_INFO_WIDTH = 360;
const TEXT_INFO_HEIGHT = 32;
const BG_COLOR_FILL = '#f9fafb';
const TEXT_COLOR_FILL = '#c2c2c2';

export interface ILoadFailImageProps {
    width: number;
    height: number;
}

export default class LoadFailImage extends React.Component<ILoadFailImageProps> {
    public static propTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    };

    public render() {
        const { width, height } = this.props;
        return (
            <>
                <rect width={width} height={height}
                    style={{ fill: BG_COLOR_FILL }}>
                </rect>
                {this.getRenderContentFromSize()}
            </>
        );
    }

    public getRenderContentFromSize() {
        const { width, height } = this.props;
        // 展示tips信息与icon
        if (height > INFO_MAX_HEIGHT && width > INFO_MAX_WIDTH) {
            return <>
                <image x="50%" y="50%" width={ICON_SIZE} height={ICON_SIZE} transform={`translate(-${ICON_SIZE / 2}, -${(ICON_SIZE / 2) + IMAGE_INFO_GAP})`} href={failImage} />
                <text x="50%" y="50%" transform={`translate(-${TEXT_INFO_WIDTH / 2}, ${TEXT_INFO_HEIGHT + IMAGE_INFO_GAP})`} fontSize="28px" fontFamily="PingFangSC" fill={TEXT_COLOR_FILL}>{LOAD_ERROR_MSG}</text>
            </>;
        }
        // 只展示icon
        if (width > ICON_SIZE && height > ICON_SIZE) {
            return <image x="50%" y="50%" width={ICON_SIZE} height={ICON_SIZE} transform={`translate(-${ICON_SIZE / 2}, -${ICON_SIZE / 2})`} href={failImage} />;
        }
        return <></>;
    }
}
